import http from "../http";

export function updateUserDefaultSetting(userDefaultSetting) {
  return http.post('/user-settings', userDefaultSetting)
}

export function getUserDefaultSetting() {
  return http.get('/user-settings')
}